export default {
  methods: {
    phone(value, precision) {
      if (value === '' || value === null || typeof value === 'undefined') {
        return ''
      }
      value = value.toString()

      return value
        .replace(' ', '')
        .replace(/^0(.)/g, '+33 $1')
        .replace(/(\d)(?=(\d{2})+(?!\d))/g, '$1 ')
    },
    remove_phone(value) {
      if (typeof value === 'undefined' || value === null) {
        return 0
      }
      value = value.toString().replace(/[^\d\\+]/g, '')

      return value
    },
  },
}
